<template>
  <div id="code-verification" v-if="visibility">
    <div class="shadow"></div>
    <div class="container">
      <hr>
      <div class="close">
        <i class="material-icons">close</i>
      </div>
      <div class="icon">
        <div class="icon-circle">
          <i class="material-icons">email</i>
        </div>
      </div>
      <header>
        <h5>Na podany email został wysłany kod aktywacyjny. Prosimy o wpisanie go w celu weryfikacji danych.</h5>
      </header>
      <div class="input-container">
        <div class="input-box">
          <input type="number" :class="{ 'data error': !validatedCode, data: validatedCode }" placeholder="Kod" v-model="code">
          <i class="material-icons" v-if="!validatedCode">close</i>
        </div>
        <p v-if="!validatedCode">{{ errorMessage }}</p>
      </div>
      <div class="flex-button">
        <button class="default small" @click="sendCode">Potwierdź</button>
      </div>
      <p class="link" @click="sendNewCode">Wyślij ponownie kod</p>
      <div class="flex-button">
        <button class="default black small" @click="logout()">Wyloguj</button>
      </div>
      <hr>
    </div>
  </div>
</template>

<script>
  import validation from '../functions/validation';

  export default {
    name: 'CodeVerification',
    data() {
      return{
        validatedCode: true,
        code: '',
        errorMessage: '',
      }
    },
    methods: {
      logout() {
        this.$emit('logout');
        this.$store.commit('togglePopupCode', 0);
      },
      async sendCode() {
        if(validation.isEmpty(this.code)) {
          this.validatedCode = false;
          this.errorMessage = 'Pole kod jest puste';
        } else {
          const payload = {
            code: this.code
          };
          await this.axios
          .put(this.api + 'auth/activation', payload)
          .then(response => {
            if(response) {
              if(response.data.status == 1) {
                this.$emit('loggedIn');
                this.$store.commit('togglePopupCode', 0);
              } else {
                this.validatedCode = false;
                this.errorMessage = response.data.msg;
              }
            }
          });
        }
      },
      async sendNewCode() {
        await this.axios
        .put(this.api + 'auth/activation/new',)
        .then(response => {
          if(response.data.status == 1) {
            this.toggleAlert(1, response.data.msg);
          } else {
            this.toggleAlert(0, response.data.msg);
          }
        });
      },
      toggleAlert(type, msg) {
        this.$store.commit('toggleAlert', {
            visibility: 1,
            type: type,
            msg: msg
        });
      },
    },
    computed:{
      visibility(){
        return this.$store.state.popupCode;
      },
      api(){
        return this.$store.state.api;
      },
    },
    mounted() {
      this.validatedCode = true;
      this.code = '';
      this.errorMessage = '';
    }
  }
</script>
<style scoped lang="scss">
  div#code-verification { display: flex; justify-content: center; align-items: center; width: 100vw; height: 100vh; position: fixed; top: 0; left: 0; z-index: 3; }
  div.shadow { width: 100vw; height: 100vh; position: absolute; top: 0; left: 0; background: rgba(0, 0, 0, 0.5); z-index: 3; }
  div.container { width: 450px; max-height: calc(100vh - 50px); background: #fff; border-radius: 3px; z-index: 4; overflow-y: auto; position: relative; }
  div.container div.close { display: flex; display: none; justify-content: center; align-items: center; width: 50px; height: 50px; margin-left: auto; 
    cursor: pointer; }
  div.container div.close i.material-icons { color: $grayLight; font-size: 26px; }
  div.container div.close:hover i.material-icons { color: $orangeDark; }
  div.container div.icon { display: flex; justify-content: center; align-items: center; width: 110px; height: 110px; margin: 5px auto 0 auto; position: absolute; 
    top: 0; left: calc(50% - 55px); background: #fff; }
  div.container div.icon div.icon-circle { display: flex; justify-content: center; align-items: center; width: 80px; height: 80px;
    border-radius: 50%; border: 2px solid $grayLighter2;  }
  div.container div.icon div.icon-circle i.material-icons { color: $grayLighter2; font-size: 28px; }
  div.container header { width: 400px; margin: 30px auto; text-align: center; }
  div.container header h5 { margin: 0; padding: 0; font-size: 15px; color: $grayLight; font-weight: 400;  }
  div.container div.input-container { width: 350px; margin: 0 auto; }
  div.container div.input-container div.input-box { width: 160px; margin: 0 auto; }
  div.container div.input-container div.input-box input { width: 160px; }
  div.container div.input-container p { width: 250px; margin: 10px auto; text-align: center; }
  div.container div.flex-button { display: flex; justify-content: center; margin: 10px 0; }
  div.container div.flex-button button { width: 160px; }
  div.container hr { width: 100%; margin: 60px 0; height: 1px; outline: 0; border: 0; background: $grayLighter2;}
  div.container hr:last-child { margin: 20px 0 60px 0; }
  .link { margin: 10px auto; padding: 0; text-align: center; color: $orangeDark; font-size: 10px; cursor: pointer; }
  .link:hover { text-decoration: underline; }
</style>
